<div class="cm-page animate-fade-in">

  <!-- Header -->
  <header class="cm-header">
    <div class="cm-header__title">
      <svg class="cm-header__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
      </svg>
      <div>
        <h1 class="cm-header__headline">Content Manager</h1>
        <p class="cm-header__sub">Browse, approve and publish generated content.</p>
      </div>
    </div>
    <div class="cm-header__actions">
      @if (selectedCount() > 0) {
        <button type="button" class="cm-filter-btn cm-filter-btn--danger" (click)="openBulkDeleteModal()">
          Delete {{ selectedCount() }} selected
        </button>
      }
    <button type="button" class="cm-filter-btn cm-filter-btn--create" (click)="openCreateModal()" aria-label="Create new content">
      <svg class="cm-filter-btn__icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
      </svg>
      Create Content
    </button>
    </div>
  </header>

  <!-- Search -->
  <div class="cm-search-wrap">
    <label for="cm-search" class="sr-only">Search contents</label>
    <svg class="cm-search-icon" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"/>
    </svg>
    <input
      id="cm-search"
      type="search"
      class="cm-search-input"
      placeholder="Search by title or tag…"
      [value]="filterSearch()"
      (input)="onSearchInput($any($event.target).value)"
      aria-label="Search contents"
    />
  </div>

  <!-- Filters -->
  <div class="cm-filters">
    <div class="cm-drop" (click)="$event.stopPropagation()">
      <button type="button" class="cm-filter-select" aria-label="Filter by app" aria-haspopup="listbox" [attr.aria-expanded]="filterMenus.app.open()" (click)="toggleFilterMenu('app')">
        <span>{{ appFilterLabel() }}</span>
        <svg class="cm-drop__chevron" [class.cm-drop__chevron--open]="filterMenus.app.open() && !filterMenus.app.closing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
        </svg>
      </button>
      @if (filterMenus.app.open()) {
        <div class="cm-drop__menu" [class.cm-drop__menu--closing]="filterMenus.app.closing()" role="listbox" aria-label="Filter by app">
          <button type="button" class="cm-drop__option" role="option" [attr.aria-selected]="!filterAppId()" [class.cm-drop__option--active]="!filterAppId()" (click)="chooseAppFilter('')">All Apps</button>
          @for (app of apps(); track app.app_id) {
            <button type="button" class="cm-drop__option" role="option" [attr.aria-selected]="filterAppId() === app.app_id" [class.cm-drop__option--active]="filterAppId() === app.app_id" (click)="chooseAppFilter(app.app_id)">{{ app.app_name }}</button>
          }
        </div>
      }
    </div>

    <div class="cm-drop" (click)="$event.stopPropagation()">
      <button type="button" class="cm-filter-select" aria-label="Filter by approval" aria-haspopup="listbox" [attr.aria-expanded]="filterMenus.approval.open()" (click)="toggleFilterMenu('approval')">
        <span>{{ approvalFilterLabel() }}</span>
        <svg class="cm-drop__chevron" [class.cm-drop__chevron--open]="filterMenus.approval.open() && !filterMenus.approval.closing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
        </svg>
      </button>
      @if (filterMenus.approval.open()) {
        <div class="cm-drop__menu" [class.cm-drop__menu--closing]="filterMenus.approval.closing()" role="listbox" aria-label="Filter by approval">
          <button type="button" class="cm-drop__option" role="option" [attr.aria-selected]="filterApproved() === ''" [class.cm-drop__option--active]="filterApproved() === ''" (click)="chooseApprovalFilter('')">All</button>
          <button type="button" class="cm-drop__option" role="option" [attr.aria-selected]="filterApproved() === 'true'" [class.cm-drop__option--active]="filterApproved() === 'true'" (click)="chooseApprovalFilter('true')">Approved</button>
          <button type="button" class="cm-drop__option" role="option" [attr.aria-selected]="filterApproved() === 'false'" [class.cm-drop__option--active]="filterApproved() === 'false'" (click)="chooseApprovalFilter('false')">Not Approved</button>
        </div>
      }
    </div>

    <div class="cm-drop" (click)="$event.stopPropagation()">
      <button type="button" class="cm-filter-select" aria-label="Filter by language" aria-haspopup="listbox" [attr.aria-expanded]="filterMenus.language.open()" (click)="toggleFilterMenu('language')">
        <span>{{ languageFilterLabel() }}</span>
        <svg class="cm-drop__chevron" [class.cm-drop__chevron--open]="filterMenus.language.open() && !filterMenus.language.closing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
        </svg>
      </button>
      @if (filterMenus.language.open()) {
        <div class="cm-drop__menu" [class.cm-drop__menu--closing]="filterMenus.language.closing()" role="listbox" aria-label="Filter by language">
          <button type="button" class="cm-drop__option" role="option" [attr.aria-selected]="!filterLanguage()" [class.cm-drop__option--active]="!filterLanguage()" (click)="chooseLanguageFilter('')">All Languages</button>
          @for (lang of languages; track lang.code) {
            <button type="button" class="cm-drop__option" role="option" [attr.aria-selected]="filterLanguage() === lang.code" [class.cm-drop__option--active]="filterLanguage() === lang.code" (click)="chooseLanguageFilter(lang.code)">{{ lang.name }}</button>
          }
        </div>
      }
    </div>

    <div class="cm-drop" (click)="$event.stopPropagation()">
      <button type="button" class="cm-filter-select" aria-label="Sort order" aria-haspopup="listbox" [attr.aria-expanded]="filterMenus.sort.open()" (click)="toggleFilterMenu('sort')">
        <span>{{ sortFilterLabel() }}</span>
        <svg class="cm-drop__chevron" [class.cm-drop__chevron--open]="filterMenus.sort.open() && !filterMenus.sort.closing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
        </svg>
      </button>
      @if (filterMenus.sort.open()) {
        <div class="cm-drop__menu" [class.cm-drop__menu--closing]="filterMenus.sort.closing()" role="listbox" aria-label="Sort order">
          <button type="button" class="cm-drop__option" role="option" [attr.aria-selected]="filterSortOrder() === 'newest_first'" [class.cm-drop__option--active]="filterSortOrder() === 'newest_first'" (click)="chooseSortFilter('newest_first')">Newest first</button>
          <button type="button" class="cm-drop__option" role="option" [attr.aria-selected]="filterSortOrder() === 'oldest_first'" [class.cm-drop__option--active]="filterSortOrder() === 'oldest_first'" (click)="chooseSortFilter('oldest_first')">Oldest first</button>
        </div>
      }
    </div>
  </div>

  @if (errorMsg()) {
    <div class="cm-error" role="alert">{{ errorMsg() }}</div>
  }

  <!-- Table -->
  <div class="cm-table-wrap">
    @if (isLoading()) {
      <div class="cm-loading" role="status" aria-live="polite">
        <svg class="cm-loading__spinner" fill="none" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="opacity-25"/><path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" class="opacity-75"/></svg>
        Loading…
      </div>
    } @else if (contents().length === 0) {
      <div class="cm-empty">
        <svg width="36" height="36" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
        <p>No content found.</p>
      </div>
    } @else {
      <table class="cm-table" aria-label="Content list">
        <thead class="cm-table__head">
          <tr>
            <th class="cm-th cm-th--check">
              <input
                type="checkbox"
                class="cm-checkbox"
                [checked]="allSelected()"
                (change)="toggleSelectAll()"
                aria-label="Select all on this page"
              />
            </th>
            <th class="cm-th">Title</th>
            <th class="cm-th">App</th>
            <th class="cm-th">Language</th>
            <th class="cm-th">Model</th>
            <th class="cm-th">Approved</th>
            <th class="cm-th">Created</th>
            <th class="cm-th cm-th--actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (group of groupedContents(); track group.id) {
            <tr class="cm-row" [class.cm-row--selected]="isSelected(group.id)" (dblclick)="openEditModal(group)" role="button" tabindex="0" (keydown.enter)="openEditModal(group)" (keydown.space)="openEditModal(group)">
              <td class="cm-td cm-td--check" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <input
                  type="checkbox"
                  class="cm-checkbox"
                  [checked]="isSelected(group.id)"
                  (change)="toggleSelect(group.id)"
                  [attr.aria-label]="'Select ' + group.title"
                />
              </td>
              <td class="cm-td cm-td--title">
                <span class="cm-title-text" [title]="group.title">{{ group.title }}</span>
                @if (group.tags.length) {
                  <div class="cm-tags">
                    @for (tag of group.tags.slice(0, 3); track tag) {
                      <span class="cm-tag">{{ tag }}</span>
                    }
                  </div>
                }
              </td>
              <td class="cm-td cm-td--muted">{{ getAppName(group.app_id) }}</td>
              <td class="cm-td">
                @if (group.isGroup) {
                  <div style="display:flex;gap:4px;flex-wrap:wrap">
                    @for (lng of group.items; track lng.language) {
                      <span class="cm-lang-badge">{{ languageLabel(lng.language) }}</span>
                    }
                  </div>
                } @else {
                  <span class="cm-lang-badge">{{ languageLabel(group.items[0].language) }}</span>
                }
              </td>
              <td class="cm-td cm-td--model">
                @if (group.model === 'human') {
                  <span class="cm-premium-badge" aria-label="Premium – human generated">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                    Premium
                  </span>
                } @else {
                  <span class="cm-td--muted">{{ group.model }}</span>
                }
              </td>
              <td class="cm-td">
                <button type="button" class="cm-approve-btn"
                  [class.cm-approve-btn--yes]="group.is_approved"
                  [class.cm-approve-btn--no]="!group.is_approved"
                  [disabled]="!group.image_path?.trim()"
                  (click)="toggleApprove(group)"
                  [attr.aria-label]="group.is_approved ? 'Revoke approval' : 'Approve content'"
                  [title]="!group.image_path?.trim() ? 'Image is required to approve' : null">
                  @if (group.is_approved) {
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1.5 6l3 3 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
                    Approved
                  } @else {
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                    Pending
                  }
                </button>
              </td>
              <td class="cm-td cm-td--muted">{{ group.created_at | date:'dd MMM y' }}</td>
              <td class="cm-td cm-td--actions" (dblclick)="$event.stopPropagation()">
                <button type="button" class="cm-action-btn" (click)="openEditModal(group)" aria-label="Edit content">
                  <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
                </button>
                <button type="button" class="cm-action-btn cm-action-btn--danger" (click)="openDeleteModal(group)" aria-label="Delete content">
                  <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  <!-- Pagination -->
  @if (!isLoading() && contents().length > 0) {
    <div class="cm-pagination">
      <span class="cm-pagination__info">Page {{ page() + 1 }}</span>
      <div class="cm-pagination__btns">
        <button type="button" class="cm-pagination__btn" (click)="prevPage()" [disabled]="!hasPrev()">← Prev</button>
        <button type="button" class="cm-pagination__btn" (click)="nextPage()" [disabled]="!hasNext()">Next →</button>
      </div>
    </div>
  }

</div>

<!-- ── Create Modal ────────────────────────────────────────────────────────── -->
@if (showCreateModal()) {
  <div class="cm-modal-backdrop cm-modal-backdrop--animate" [class.cm-modal-backdrop--closing]="createClosing()" role="dialog" aria-modal="true" aria-labelledby="cm-create-title" (click)="closeCreateModal()">
    <div class="cm-modal cm-modal--lg cm-modal--animate" [class.cm-modal--closing]="createClosing()" (click)="$event.stopPropagation()">
      <div class="cm-modal__header">
        <h3 id="cm-create-title" class="cm-modal__title">Create Content</h3>
        <button type="button" class="cm-modal__close" (click)="closeCreateModal()" aria-label="Close">
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <form [formGroup]="createForm" class="cm-modal__body">
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:1.1rem">
          <div class="cm-form-group">
            <label class="cm-form-label" for="create-app">App *</label>
            <select id="create-app" formControlName="app_id" class="cm-form-input"
              [class.cm-form-input--error]="createForm.get('app_id')?.invalid && createForm.get('app_id')?.touched"
              (change)="onCreateAppChange($any($event.target).value)">
              <option value="">Select app…</option>
              @for (app of apps(); track app.app_id) {
                <option [value]="app.app_id">{{ app.app_name }}</option>
              }
            </select>
            @if (createForm.get('app_id')?.invalid && createForm.get('app_id')?.touched) {
              <span class="cm-form-error" role="alert">App is required</span>
            }
          </div>



          <div class="cm-form-group">
            <label class="cm-form-label" for="create-language">Language *</label>
            <select id="create-language" formControlName="language" class="cm-form-input"
              [class.cm-form-input--error]="createForm.get('language')?.invalid && createForm.get('language')?.touched">
              <option value="">Select language…</option>
              @for (lang of languages; track lang.code) {
                <option [value]="lang.code">{{ lang.name }}</option>
              }
            </select>
            @if (createForm.get('language')?.invalid && createForm.get('language')?.touched) {
              <span class="cm-form-error" role="alert">Language is required</span>
            }
          </div>

          <div class="cm-form-group">
            <label class="cm-form-label">Model</label>
            <div class="cm-form-input cm-form-input--readonly" aria-readonly="true">
              <span class="cm-premium-badge" aria-label="Human generated">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                Human
              </span>
            </div>
          </div>
        </div>

        <div class="cm-form-group">
          <label class="cm-form-label">Translate to</label>
          <div class="cm-chips">
            @for (lang of languages; track lang.code) {
              @if (lang.code !== createForm.get('language')?.value) {
                <label class="cm-chip" style="display:inline-flex;align-items:center;gap:0.4rem;cursor:pointer;">
                  <input
                    type="checkbox"
                    [checked]="createTargetLanguages().includes(lang.code)"
                    (change)="toggleCreateTargetLanguage(lang.code, $any($event.target).checked)" />
                  <span>{{ lang.name }}</span>
                </label>
              }
            }
          </div>
        </div>

        <div class="cm-form-group">
          <label class="cm-form-label" for="create-title">Title *</label>
          <input id="create-title" type="text" formControlName="title" class="cm-form-input"
            [class.cm-form-input--error]="createForm.get('title')?.invalid && createForm.get('title')?.touched">
          @if (createForm.get('title')?.invalid && createForm.get('title')?.touched) {
            <span class="cm-form-error" role="alert">Title is required</span>
          }
        </div>

        <div class="cm-form-group">
          <label class="cm-form-label" for="create-image-path">Image URL</label>
          <input id="create-image-path" type="url" formControlName="image_path" class="cm-form-input" placeholder="https://…">
          <button type="button" class="cm-library-toggle" (click)="toggleLibrary('create')" [attr.aria-expanded]="libraryTarget() === 'create'">
            {{ libraryTarget() === 'create' ? 'Hide library' : 'Choose from library' }}
          </button>
          @if (libraryTarget() === 'create') {
            <div class="cm-library">
              @if (libraryLoading()) {
                <p class="cm-library__state">Loading images…</p>
              } @else if (libraryError()) {
                <p class="cm-library__state">{{ libraryError() }}</p>
              } @else if (!libraryImages().length) {
                <p class="cm-library__state">No images yet. Generate one in Image Generation.</p>
              } @else {
                <div class="cm-library__grid" role="listbox" aria-label="Image library">
                  @for (image of libraryImages(); track image.generation_id) {
                    <button type="button" class="cm-library__item" role="option"
                      [class.cm-library__item--selected]="currentLibraryUrl() === image.image_url"
                      [attr.aria-selected]="currentLibraryUrl() === image.image_url"
                      [attr.aria-label]="image.prompt || 'Library image'"
                      (click)="pickLibraryImage(image.image_url)">
                      <img [src]="image.image_url" [alt]="image.prompt" loading="lazy" referrerpolicy="no-referrer">
                    </button>
                  }
                </div>
              }
            </div>
          }
          @if (createForm.get('image_path')?.value) {
            <div class="cm-image-preview">
              <img [src]="createForm.get('image_path')?.value" alt="Preview" class="cm-image-preview__img" referrerpolicy="no-referrer" (error)="$any($event.target).style.display='none'">
            </div>
          }
        </div>

        <div class="cm-form-group cm-form-group--editor">
          <label class="cm-form-label" for="create-content">Content *</label>
          <div class="cm-quill-wrap">
            <quill-editor id="create-content" formControlName="content" [modules]="quillModules"
              placeholder="Write your content…" class="cm-quill-editor"></quill-editor>
          </div>
          @if (createForm.get('content')?.invalid && createForm.get('content')?.touched) {
            <span class="cm-form-error" role="alert">Content is required</span>
          }
        </div>

        <div class="cm-form-group">
          <label class="cm-form-label" for="create-tag-input">Tags</label>
          <div class="cm-tag-input-wrap">
            <input id="create-tag-input" type="text" class="cm-form-input"
              placeholder="Type and press Enter…"
              [ngModel]="createTagInput()" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="createTagInput.set($event)"
              (keydown)="onCreateTagKeydown($event)"/>
            <button type="button" class="cm-tag-add-btn" (click)="addCreateTag(createTagInput())" aria-label="Add tag">+</button>
          </div>
          @if (createTags().length) {
            <div class="cm-chips">
              @for (tag of createTags(); track tag) {
                <span class="cm-chip">
                  {{ tag }}
                  <button type="button" class="cm-chip__remove" (click)="removeCreateTag(tag)" [attr.aria-label]="'Remove ' + tag">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                  </button>
                </span>
              }
            </div>
          }
        </div>

        @if (createError()) {
          <div class="cm-alert-error" role="alert">{{ createError() }}</div>
        }
      </form>

      <div class="cm-modal__footer">
        <div class="cm-modal__footer-left"></div>
        <div class="cm-modal__footer-right">
          <button type="button" class="cm-btn cm-btn--ghost" (click)="closeCreateModal()">Cancel</button>
          <button type="button" class="cm-btn cm-btn--primary" (click)="submitCreate()" [disabled]="isCreating() || createForm.invalid">
            @if (isCreating()) { Creating… } @else { Create }
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- ── Edit Modal ──────────────────────────────────────────────────────────── -->
@if (showEditModal()) {
  <div class="cm-modal-backdrop cm-modal-backdrop--animate" [class.cm-modal-backdrop--closing]="editClosing()" role="dialog" aria-modal="true" aria-labelledby="cm-edit-title" (click)="closeEditModal()">
    <div class="cm-modal cm-modal--lg cm-modal--animate" [class.cm-modal--closing]="editClosing()" (click)="$event.stopPropagation()">
      <div class="cm-modal__header">
        <h3 id="cm-edit-title" class="cm-modal__title">Edit Content</h3>
        <button type="button" class="cm-modal__close" (click)="closeEditModal()" aria-label="Close">
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <form [formGroup]="editForm" class="cm-edit-grid">
        <div class="cm-edit-grid__meta">
          <div class="cm-form-group">
            <label class="cm-form-label" for="edit-image-path">Image <span class="cm-form-label__hint">shared across languages</span></label>
            @if (editSharedImagePath()) {
              <div class="cm-image-preview cm-image-preview--edit">
                <img [src]="editSharedImagePath()" alt="Preview" class="cm-image-preview__img" referrerpolicy="no-referrer" (error)="$any($event.target).style.display='none'">
              </div>
            }
            <input id="edit-image-path" type="url" class="cm-form-input" placeholder="https://…"
              [value]="editSharedImagePath()"
              (input)="editSharedImagePath.set($any($event.target).value)">
            <button type="button" class="cm-library-toggle" (click)="toggleLibrary('edit')" [attr.aria-expanded]="libraryTarget() === 'edit'">
              {{ libraryTarget() === 'edit' ? 'Hide library' : 'Choose from library' }}
            </button>
            @if (libraryTarget() === 'edit') {
              <div class="cm-library">
                @if (libraryLoading()) {
                  <p class="cm-library__state">Loading images…</p>
                } @else if (libraryError()) {
                  <p class="cm-library__state">{{ libraryError() }}</p>
                } @else if (!libraryImages().length) {
                  <p class="cm-library__state">No images yet. Generate one in Image Generation.</p>
                } @else {
                  <div class="cm-library__grid" role="listbox" aria-label="Image library">
                    @for (image of libraryImages(); track image.generation_id) {
                      <button type="button" class="cm-library__item" role="option"
                        [class.cm-library__item--selected]="currentLibraryUrl() === image.image_url"
                        [attr.aria-selected]="currentLibraryUrl() === image.image_url"
                        [attr.aria-label]="image.prompt || 'Library image'"
                        (click)="pickLibraryImage(image.image_url)">
                        <img [src]="image.image_url" [alt]="image.prompt" loading="lazy" referrerpolicy="no-referrer">
                      </button>
                    }
                  </div>
                }
              </div>
            }
          </div>

          <div class="cm-form-group">
            <label class="cm-form-label" for="edit-title">Title *</label>
            <input id="edit-title" type="text" formControlName="title" class="cm-form-input"
              [class.cm-form-input--error]="editForm.get('title')?.invalid && editForm.get('title')?.touched">
            @if (editForm.get('title')?.invalid && editForm.get('title')?.touched) {
              <span class="cm-form-error" role="alert">Title is required</span>
            }
          </div>

          <div class="cm-form-group">
            <label class="cm-form-label" for="edit-tag-input">Tags</label>
            <div class="cm-tag-input-wrap">
              <input id="edit-tag-input" type="text" class="cm-form-input"
                placeholder="Type and press Enter…"
                [ngModel]="editTagInput()" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="editTagInput.set($event)"
                (keydown)="onEditTagKeydown($event)"/>
              <button type="button" class="cm-tag-add-btn" (click)="addEditTag(editTagInput())" aria-label="Add tag">+</button>
            </div>
            @if (editTags().length) {
              <div class="cm-chips">
                @for (tag of editTags(); track tag) {
                  <span class="cm-chip">
                    {{ tag }}
                    <button type="button" class="cm-chip__remove" (click)="removeEditTag(tag)" [attr.aria-label]="'Remove ' + tag">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                    </button>
                  </span>
                }
              </div>
            }
          </div>

          <div class="cm-form-group">
            <label class="cm-form-label">Language</label>
            @if (selectedGroup()?.isGroup) {
              <div class="cm-edit-langs" role="tablist" aria-label="Language">
                @for (item of selectedGroup()?.items; track item.language; let i = $index) {
                  <button type="button" class="cm-edit-lang" role="tab"
                    [class.cm-edit-lang--active]="selectedEditTabIndex() === i"
                    [attr.aria-selected]="selectedEditTabIndex() === i"
                    (click)="setEditTab(i)">
                    {{ languageLabel(item.language) }}
                    @if (item.is_approved) { <span class="cm-edit-lang__mark" aria-hidden="true">✓</span> }
                  </button>
                }
              </div>
            } @else if (activeEditItem(); as item) {
              <div class="cm-form-input cm-form-input--readonly">{{ languageLabel(item.language) }}</div>
            }
          </div>

          @if (saveError()) {
            <div class="cm-alert-error" role="alert">{{ saveError() }}</div>
          }
        </div>

        <div class="cm-edit-grid__body">
          <div class="cm-form-group cm-form-group--editor">
            <label class="cm-form-label" for="edit-content">Content *</label>
            <div class="cm-quill-wrap">
              <quill-editor id="edit-content" formControlName="content" [modules]="quillModules"
                placeholder="Write your content…" class="cm-quill-editor"></quill-editor>
            </div>
            @if (editForm.get('content')?.invalid && editForm.get('content')?.touched) {
              <span class="cm-form-error" role="alert">Content is required</span>
            }
          </div>
        </div>
      </form>

      <div class="cm-modal__footer">
        <div class="cm-modal__footer-left">
          @if (activeEditItem(); as c) {
            <button type="button" class="cm-btn cm-btn--approve"
              [class.cm-btn--approve-active]="c.is_approved"
              [disabled]="!editSharedImagePath().trim()"
              (click)="approveInModal()"
              [attr.aria-label]="c.is_approved ? 'Disapprove' : 'Approve content'"
              [title]="!editSharedImagePath().trim() ? 'Image URL is required to approve' : null">
              @if (c.is_approved) {
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                Disapprove
              } @else {
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12l5 5L20 7"/></svg>
                Approve
              }
            </button>
          }
        </div>
        <div class="cm-modal__footer-right">
          <button type="button" class="cm-btn cm-btn--ghost" (click)="closeEditModal()">Cancel</button>
          <button type="button" class="cm-btn cm-btn--primary" (click)="submitEdit()" [disabled]="isSaving() || editForm.invalid">
            @if (isSaving()) { Saving… } @else { Save }
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- ── Delete Modal ────────────────────────────────────────────────────────── -->
@if (showDeleteModal()) {
  <div class="cm-modal-backdrop cm-modal-backdrop--animate" [class.cm-modal-backdrop--closing]="deleteClosing()" role="dialog" aria-modal="true" aria-labelledby="cm-delete-title" (click)="closeDeleteModal()">
    <div class="cm-modal cm-modal--sm cm-modal--animate" [class.cm-modal--closing]="deleteClosing()" (click)="$event.stopPropagation()">
      <div class="cm-modal__header">
        <h3 id="cm-delete-title" class="cm-modal__title cm-modal__title--danger">Delete Content</h3>
        <button type="button" class="cm-modal__close" (click)="closeDeleteModal()" aria-label="Close">
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
      <div class="cm-modal__body">
        @if (selectedGroup(); as group) {
          <p class="cm-modal__text">Are you sure you want to delete <strong>{{ group.title }}</strong>? This deletes every language in the group. If its image is not used anywhere else, that image is removed too. This cannot be undone.</p>
        } @else {
          <p class="cm-modal__text">Delete <strong>{{ selectedCount() }}</strong> selected contents? Every language in those groups will be removed. Images used only by these contents will be deleted too. This cannot be undone.</p>
        }
        @if (saveError()) {
          <div class="cm-alert-error" role="alert" style="margin-top:1rem">{{ saveError() }}</div>
        }
      </div>
      <div class="cm-modal__footer">
        <button type="button" class="cm-btn cm-btn--danger" (click)="confirmDelete()" [disabled]="isSaving()">
          @if (isSaving()) { Deleting… } @else { Delete }
        </button>
      </div>
    </div>
  </div>
}
